//
//
//
//
//
//
//
//
//

export default {
  props: {
    sku: { type: String, required: true },
    width: { type: Number, default: 400 },
    height: { type: Number, default: 400 },
    bg: { type: String, default: 'f2f2f5' },
    viewAngle: { type: Number, default: 5 },
    scale: { type: Number, default: 1.4 },
    lazyLoad: { type: Boolean, default: false },
    placeholderRatio: { type: String, default: '' }
  },
  computed: {
    url () {
      return this.buildUrl()
    }
  },
  methods: {
    buildUrl (options = {}) {
      options = options || {}
      const queryString = new URLSearchParams({
        sku: options.sku || this.sku,
        width: options.width || this.width,
        height: options.height || this.height,
        bg: options.bg || this.bg,
        image_number: options.viewAngle || this.viewAngle,
        scale: options.scale || this.scale
      }).toString()
      return `https://dynamic.sungod.co/?${queryString}`
    }
  }
}
